module.exports = __webpack_public_path__ + "img/companyaddress.8461ec6d.jpg";